/** @type {HTMLElement | null} */
let currentPopup = null;

function openTaxesInfoPopup() {
  const popup = document.getElementById('taxes-info-popup');
  if (popup && popup instanceof HTMLElement) {
    currentPopup = popup;
    document.body.appendChild(popup);
    popup.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }
}

function closeTaxesInfoPopup() {
  const popup = currentPopup || document.querySelector('.info-popup[style*="block"]') || document.getElementById('taxes-info-popup');
  
  if (popup && popup instanceof HTMLElement) {
    popup.style.display = 'none';
    document.body.style.overflow = '';
    
    const wrapper = document.querySelector('.info-popup-wrapper');
    if (wrapper && popup.parentNode !== wrapper) {
      wrapper.appendChild(popup);
    }
    
    currentPopup = null;
  }
}

document.addEventListener('click', function (event) {
  const target = event.target;
  
  if (target && target instanceof HTMLElement && target.id === 'taxes-info-trigger') {
    event.preventDefault();
    openTaxesInfoPopup();
    return;
  }
  
  if (target && target instanceof HTMLElement && target.id === 'taxes-info-close') {
    event.preventDefault();
    closeTaxesInfoPopup();
    return;
  }
  
  if (target && target instanceof HTMLElement && target.id === 'taxes-info-popup') {
    closeTaxesInfoPopup();
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    if (currentPopup && currentPopup.style.display === 'block') {
      closeTaxesInfoPopup();
    }
  }
});